import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BookingSuccess.css';

export default function BookingSuccess() {
  const { state } = useLocation();
  const bookingId = state?.bookingId || 'SS-XXXXXX';
  const childName = state?.childFirst ? `${state.childFirst} ${state.childLast}` : 'Your Child';
  const svcLabels = {
    'obj-foundational': 'Object Identification: Foundational',
    'obj-advanced':     'Object Identification: Advanced',
    'obj-mastery':      'Object Identification: Mastery',
    'math-foundational':'Mathematics: Foundational',
    'math-advanced':    'Mathematics: Advanced',
    'speech-narrative': 'Speech: Storytelling & Understanding',
    'speech-phonemic':  'Speech: Sounds & Early Reading',
  };
  const svcLabel = svcLabels[state?.service] || 'Certification Session';

  return (
    <section className="success-page">
      <div className="container success-inner">
        <div className="success-icon-wrap">
          <div className="success-ring success-ring-1" />
          <div className="success-ring success-ring-2" />
          <div className="success-checkmark">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
        </div>

        <div className="badge badge-gold" style={{ marginBottom: '16px' }}>
          Booking Confirmed
        </div>

        <h1 className="success-title">You're all set!</h1>
        <p className="success-sub">
          {childName}'s <strong>{svcLabel}</strong> session has been booked.
          {state?.date && ` We'll see you on ${state.date} at ${state.time}.`}
        </p>

        <div className="success-details">
          <div className="sd-row">
            <span>Booking Reference</span>
            <span className="sd-val mono">{bookingId}</span>
          </div>
          {state?.email && (
            <div className="sd-row">
              <span>Confirmation sent to</span>
              <span className="sd-val">{state.email}</span>
            </div>
          )}
          {state?.date && (
            <div className="sd-row">
              <span>Date &amp; Time</span>
              <span className="sd-val">{state.date} at {state.time}</span>
            </div>
          )}
          {state?.mode && (
            <div className="sd-row">
              <span>Session Type</span>
              <span className="sd-val" style={{ textTransform: 'capitalize' }}>{state.mode}</span>
            </div>
          )}
        </div>

        <div className="success-next-steps">
          <h3>What Happens Next?</h3>
          {[
            'Check your email. Your confirmation and calendar invite are on their way.',
            'A SKIES consultant will be assigned to your appointment within 2 hours.',
            'You\'ll receive a reminder 24 hours before your session.',
            'On the day, simply join the video call and let your child shine!',
          ].map((step, i) => (
            <div key={i} className="ns-item">
              <span className="ns-num">{i + 1}</span>
              <p>{step}</p>
            </div>
          ))}
        </div>

        <div className="success-actions">
          <Link to="/" className="btn btn-primary btn-lg">Back to Home</Link>
          <Link to="/blog" className="btn btn-dark btn-lg">Read Our Blog</Link>
        </div>
      </div>
    </section>
  );
}
